'use strict';
// var cleave = require('./components/cleave');
var slickConfigs = require('../js/config/slickConfigs');


/**
 * Validate Phone input
 * @param {Object} input - input phone
 * @returns {Object} thisInput
 */
function phoneFormatAusMobile(input) {
    // Strip all characters from the input except digits
    var thisInput = input;
    thisInput = thisInput.replace(/\D/g, '');

    // Trim the remaining input to ten characters, to preserve phone number format
    thisInput = thisInput.substring(0, 10);

    return thisInput;
}

/**
 * Validate Phone input
 * @param {Object} input - input phone
 * @returns {Object} thisInput
 */
function phoneFormatAus(input) {
    // Strip all characters from the input except digits
    var thisInput = input;
    thisInput = thisInput.replace(/\D/g, '');

    // Trim the remaining input to ten characters, to preserve phone number format
    thisInput = thisInput.substring(0, 10);

    // Based upon the length of the string, we add formatting as necessary
    var size = thisInput.length;

    if (size === 0) {
        thisInput = input;
    } else if (size < 3) {
        thisInput = '(' + thisInput;
    } else if (size < 7) {
        thisInput = '(' + thisInput.substring(0, 2) + ') ' + thisInput.substring(2, 6);
    } else {
        thisInput = '(' + thisInput.substring(0, 2) + ') ' + thisInput.substring(2, 6) + '-' + thisInput.substring(6, 10);
    }

    return thisInput;
}

/**
 * Add Formatting on Phone Number
 * @param {Object} phoneFieldSelector - field selector
function phoneNumberFormat(phoneFieldSelector) {
    if ($('input[name$=aus]').val() !== 'AU') {
        cleave.handleFormatPhoneNumber(phoneFieldSelector);
    }
}*/

/**
 * Add Validation on Name
 * @param {Object} nameField - field selector
 */
function nameValidation(nameField) {
    $(nameField).addClass('is-invalid');
    var parent = $(nameField).closest('.form-float-container');
    var invalid = $(parent).find('.invalid-feedback');
    $(invalid).addClass('is-invalid').text('Digits are not allowed.');
}

/**
 * Add Validation on Comments
 * @param {Object} commentField - field selector
 * @param {string} regexError - string
 */
function commentValidation(commentField, regexError) {
    $(commentField).addClass('is-invalid');
    var parent = $(commentField).closest('.form-float-container');
    var invalid = $(parent).find('.invalid-feedback');
    if (regexError && regexError === 'true') {
        $(invalid).addClass('is-invalid').text('Only text is allowed. Remove all special characters except " . "');
    } else {
        $(invalid).addClass('is-invalid').text('Please fill out this field.');
    }
}

$(document).ready(function () {
    /* if ($('#PhoneNumber')) {
        phoneNumberFormat($('#PhoneNumber'));
    } */

    // eslint-disable-next-line require-jsdoc
    function privacySlickSlider() {
        $('.privacySlider').slick(slickConfigs.privacySlider);
    }

    // eslint-disable-next-line require-jsdoc
    function privacyDestroySlickSlider() {
        if ($('.privacySlider').hasClass('slick-initialized')) {
            $('.privacySlider').slick('unslick');
        }
    }

    if ($(window).width() < 960) {
        privacySlickSlider();
    }

    $(window).on('resize', function () {
        if ($(window).width() < 960) {
            privacySlickSlider();
        } else {
            privacyDestroySlickSlider();
        }
    });

    var urlParams = new URLSearchParams(window.location.search);
    var anyMsg = urlParams.get('msg');
    if (anyMsg === 'success' || anyMsg === 'error') {
        $('body,html').animate({
            scrollTop: $('.privacy-form').offset().top
        }, 800);

        if (anyMsg === 'success') {
            $('.privacy-form__result').addClass('alert alert-success').text('Submission Successful');
        } else {
            $('.privacy-form__result').addClass('alert alert-danger').text('Oops! something went wrong. Please try again');
        }
    }

    var regexp = /\d/;
    $('.privacy-form__submit').off('click').on('click', function (e) {
        var firstName = $('#FirstName');
        var lastName = $('#LastName');
        var comment = $('#Comments');
        var firstNameVal = $(firstName).val();
        var lastNameVal = $(lastName).val();
        var commentVal = $(comment).val();

        if (regexp.test(firstNameVal)) {
            e.preventDefault();
            nameValidation(firstName);
        }
        if (regexp.test(lastNameVal)) {
            e.preventDefault();
            nameValidation(lastName);
        }
        if (!commentVal || !commentVal.trim()) {
            commentValidation(comment);
        } else {
            var commentsRegex = /[^A-za-z0-9. ]/g;
            if (commentsRegex.test(commentVal)) {
                commentValidation(comment, 'true');
                e.preventDefault();
            }
        }
        if ($(".js-form-checkboxes-ctnr input[type='checkbox']:checked").length) {
            $(".js-form-checkboxes-ctnr input[type='checkbox']:checked").each(function () {
                $(this).val('true');
            });
        }
    });

    $(document).on('click', '.js-Back-to-Top', function () {
        $('html,body').animate({
            scrollTop: 0
        }, 1000);
    });

    $('.privacyWithArlo-list li').click(function (e) {
        e.preventDefault();
        var url = $(this).find('a').attr('href');
        window.open(url, '_blank');
    });
});

/**
 * listener for phoneFormat
 * @param {event} keyup - listener
 */
$('#PhoneNumber').on('change paste keyup', function () {
    var phoneNumber = document.getElementById('PhoneNumber');
    // var charCode = (evt.which) ? evt.which : evt.keyCode;
    var aus = $('input[name=aus]').val();
    if (aus === 'AU') {
        if (phoneNumber.value.substring(0, 2) === '04' || phoneNumber.value.substring(0, 3) === '(04') {
            phoneNumber.value = phoneFormatAusMobile(phoneNumber.value);
        } else {
            phoneNumber.value = phoneFormatAus(phoneNumber.value);
        }
    }
});
